import logo from '../assets/logo.png';

export default function PageHero({ tag, tagColor='rgba(255,255,255,.75)', title, subtitle, from, to }) {
  return (
    <div className="page-hero" style={{ background:`linear-gradient(140deg,${from},${to})` }}>
      <img src={logo} alt="" className="bg-logo" />
      <div className="flag" style={{ height:3 }}><span /><span /><span /></div>
      <div className="hero-body">
        <div style={{ marginBottom:16 }}>
          <span className="tag" style={{ color:tagColor }}>
            <span className="tag-bar" style={{ background:tagColor }} />
            {tag}
            <span className="tag-bar" style={{ background:tagColor }} />
          </span>
        </div>
        <h1>{title}</h1>
        {subtitle && <p className="sub">{subtitle}</p>}
      </div>
    </div>
  );
}
